module.exports = __webpack_public_path__ + "static/GT-America-Condensed-Bold.3c3f4fa7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-America-Condensed-Bold.woff
// module id = 447
// module chunks = 168707334958949